import flatten from 'flat';
import home from './en-US/home';

export default flatten({
  ...home,
});
